<template>
  <transition name="fade">
    <div class="level3-modal-container">
      <div class="lv3-title-text">Edit Direktur Data</div>
      <div class="lv3-edit-form" style="overflow-y: hidden !important">
        <div class="edit-form-wrapper">
          <div>Nama</div>
          <input class="lv3-input-text" :placeholder="data.name" type="text" v-model="data.name">
        </div>
        <div class="edit-form-wrapper">
          <div>Jabatan</div>
          <input class="lv3-input-text" :placeholder="data.jabatan" type="text" v-model="data.jabatan">
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Handphone</div>
          <input class="lv3-input-text" :placeholder="data.department" type="text" v-model="data.department">
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      email: null,
      customText : null,
      tempText : null,
      data: {
        name: 'Bhakti',
        jabatan: 'Sales',
        department: 'Marketing'
      },
    }
  },
  methods: {
    closeModal() {
      const self = this
      self.$store.commit('modalStore/SET_IDENTITY_MODAL', false)
    },
    confirm() {
      this.$emit('confirmed', this.data)
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~/assets/scss/components/login.scss";
</style>
